import { dbReadOnce } from './common';

export const dbGetUserByUidOnce = (uid: string, callback: any) => {
  dbReadOnce({ refPath: `users/${uid}` }, callback);
};
